import { useMutation } from '@tanstack/react-query'

import { downloadFileRequest } from './request'

export const useDownloadFileMutation = () =>
  useMutation({ mutationFn: downloadFileRequest })
